import { Link } from "react-router-dom";
import React from "react";
const SensorSidebar = ({ token, username, isActive, onToggle }) => {
  if (username.bedrijf && username.bedrijf.modules.includes("sensoren")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker") {
      function addsensor() {
        if (token.role === "admin" || token.role === "manager") {
          return (
            <>
            <div className="menu-item">
              <Link to="/sensoren/sensor/toevoegen" className="menu-link">
                <span className="menu-icon"><i className="fa fa-plus"></i></span>
                <span className="menu-text">Sensor toevoegen</span>
              </Link>
            </div>
                  <div className="menu-item">
              <Link to="/sensoren/sensor/importeren" className="menu-link">
                <span className="menu-icon"><i className="fa fa-upload"></i></span>
                <span className="menu-text">CSV Importeren</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/sensoren/sensor/chirpstack-import" className="menu-link">
                <span className="menu-icon"><i className="fa fa-cloud-download"></i></span>
                <span className="menu-text">ChirpStack Import</span>
              </Link>
            </div>
            </>
          );
        }
      }

      function addprofile() {
        if (token.role === "admin" || token.role === "manager") {
          return (
            <>
              {" "}
              <div className="menu-item">
                <Link to="/sensoren/alertprofile" className="menu-link">
                  <span className="menu-icon"><i className="fa fa-edit"></i></span>
                  <span className="menu-text">Notificatie instellingen</span>
                </Link>
              </div>
              <div className="menu-item">
                <Link to="/sensoren/instellingen" className="menu-link">
                  <span className="menu-icon"><i className="fa fa-gear"></i></span>
                  <span className="menu-text">Sensor instellingen</span>
                </Link>
              </div>
            </>
          );
        }
      }

      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon"><i className="fas fa-project-diagram"></i></span>
            <span className="menu-text">Sensoren</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}><i className="fas fa-chevron-right"></i></span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/sensoren/" className="menu-link">
                <span className="menu-icon"><i className="fa fa-search"></i></span>
                <span className="menu-text">Sensoren</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/sensoren/rapportage" className="menu-link">
                <span className="menu-icon"><i className="fa fa-chart-simple"></i></span>
                <span className="menu-text">Sensoren rapportage</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/sensoren/map" className="menu-link">
                <span className="menu-icon"><i className="fa fa-map"></i></span>
                <span className="menu-text">Sensoren op kaart</span>
              </Link>
            </div>
            {addsensor()}
            {addprofile()}
          </div>
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default SensorSidebar;
